import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "box-row full-width q-py-xs" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "content q-pl-sm" }
const _hoisted_4 = { class: "text-subtitle2" }
const _hoisted_5 = { class: "text-body2" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "box-row full-width" }
const _hoisted_8 = { class: "content" }
const _hoisted_9 = { class: "text-subtitle2" }
const _hoisted_10 = { class: "text-body2" }
const _hoisted_11 = { class: "" }
const _hoisted_12 = { class: "footer" }
const _hoisted_13 = { class: "text-subtitle2" }
const _hoisted_14 = {
  key: 0,
  class: "q-px-md"
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "q-px-md" }
const _hoisted_17 = { class: "text-subtitle2" }
const _hoisted_18 = { class: "text-body2" }
const _hoisted_19 = { class: "" }
const _hoisted_20 = { class: "q-mt-md" }
const _hoisted_21 = { class: "q-pt-sm" }
const _hoisted_22 = { class: "q-pt-md" }
const _hoisted_23 = {
  key: 1,
  class: "box-row full-width q-pa-md"
}
const _hoisted_24 = { class: "header" }
const _hoisted_25 = { class: "content q-pl-sm" }
const _hoisted_26 = { class: "text-subtitle2" }
const _hoisted_27 = { class: "text-body2" }
const _hoisted_28 = { class: "q-mt-xs" }
const _hoisted_29 = { class: "q-mt-md" }
const _hoisted_30 = { key: 0 }

import { PropType, ref, onMounted, computed, watch } from "vue";
  import { useRouter } from "vue-router"; 
  import { Dialog, QInput, QSelect } from "quasar";
  // Stores and services
  import { useProposalStore } from "src/stores/proposal-store";
  import { useVehicleStore } from "src/stores/vehicle-store";
  import { useAuthStore } from "src/stores/auth-store";
  import { useSettingsStore } from "src/stores/settings-store";
  import { VehicleService } from "src/services";
  // Components
  import VehicleAvatar from "src/components/vehicle/VehicleAvatar.vue";
  import QuoteEditor from "./QuoteEditor.vue";
  import QuoteViewer from "./QuoteViewer.vue";
  import CurrencyInput from "src/components/form/inputs/CurrencyInput.vue";
  import VehicleLookup from "src/components/form/lookups/VehicleLookup.vue";
  // Types
  import { LoanApplication, Vehicle } from "src/types/loan-application/index";
  import { QuickQuote, QuoteFilter } from "src/types/quote/index";
  import { GlassesValuationResponse, CapValuationResponse } from "src/types/vehicle-search/index";
  // Functions
  import {
    useHideLoading, useLoading, EVENTS, logEvent, useSanitiseReg, useCurrencyFormatter,
    useFutures, useMockHpProposal, useMockPrimeProposals
  } from "src/functions";
  //@ts-ignore
  import { calculateMonthlyPaymentForVehicle } from "@cf247/pricing/src/monthly-payment-calculator";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Quotes',
  props: {
    application: {
      type: Object as PropType<LoanApplication>,
      default: null
    },
    otherApplications: {
      type: Array as PropType<LoanApplication[]>,
      default: []
    },
    loading: {
      type: Boolean,
      default: false
    },
    quickQuote: {
      type: Boolean,
      default: false
    },
  },
  emits: ['newQuickQuote', 'selectQuickQuote'],
  setup(__props, { emit: __emit }) {

  const proposalStore = useProposalStore();
  const vehicleStore = useVehicleStore();
  const router = useRouter();
  const settingsStore = useSettingsStore();

  const isMobile = computed(() => settingsStore.isMobile);

  const props = __props

  const filters = ref({
    price: 0,
    mileage: 0,
    deposit: 0,
    pxValue: 0,
    settlement: 0,
    annualMileage: proposalStore.defaultPcpMileage,
    creditScore: 2
  } as QuoteFilter);

  onMounted(() => {
    setupApp()
  })
  watch(() => props.application, () => {
    setupApp();
  })
  function setupApp() {
    if (props.application && props.application.vehicle) {
      filters.value = {
        price: props.application.vehicle.price,
        mileage: props.application.vehicle.mileage,
        deposit: props.application.deposit ?? 0,
        pxValue: props.application.pxValue ?? 0,
        settlement: props.application.settlement ?? 0,
        annualMileage: props.application.vehicle && props.application.vehicle.annualMileage ? props.application.vehicle.annualMileage : proposalStore.defaultPcpMileage,
        creditScore: props.application.creditProfile ?? 2
      } as QuoteFilter
    }

    if ((props.application.isQuickQuote || (props.application.proposals && props.application.proposals.length > 0)) && !props.loading) {
      calculatePrice();
    }
  }

  const termsToShow = computed(() => settingsStore.termsToShow);

  watch(() => props.loading, (newVal: boolean, oldVal: boolean) => {
    if (oldVal && !newVal) {
      calculatePrice();
    }
  })

  const vehicleLookup = ref<QSelect | null>(null);
  const newVehPanel = ref("btn");
  const stock = computed(() => vehicleStore.vehicles);
  const expandAdditional = ref(false);
  watch(() => expandAdditional.value, (newVal: boolean, oldVal: boolean) => {
    if (!newVal && oldVal) {
      newVehPanel.value = "btn";
      newVehicle.value = null;
    }
  })
  const selectVehicle = ref(false);
  function newQuote() {
    newVehPanel.value = "veh";
    setTimeout(() => { vehicleLookup.value!.focus() }, 100)
  }
  const newVehicle = ref<Vehicle | null>(null);
  function vehicleFound(v: Vehicle) {
    newVehicle.value = v;
    if (v.isIntranetLoanVehicle) {

    }
    else {
      saveQuickQuote();
    }
    
  }

  const emit = __emit;

  async function saveQuickQuote() {
    useLoading("Generating Quick Quote. This may take a moment as we run some vehicle checks.")

    let glasses: GlassesValuationResponse | null = null;
    let cap: CapValuationResponse | null = null;
    let regYear = newVehicle.value && newVehicle.value.vehicleDateOfFirstReg ? new Date(newVehicle.value!.vehicleDateOfFirstReg).getFullYear() : null;

    if (!regYear) {
      Dialog.create({
        message: "Unable to determine registration year"
      })
      return;
    }
    
    try {
      const tasks: Promise<any>[] = [];
      tasks.push(VehicleService.glassesValuation(newVehicle.value!.vehicleRegistration, newVehicle.value!.mileage).then(response => {
        glasses = response;
      }));
      tasks.push(VehicleService.capValuation(newVehicle.value!.capId, newVehicle.value!.mileage, newVehicle.value!.vehicleRegistration, regYear).then(response => {
        cap = response;
      }));

      await Promise.all(tasks)
      if (glasses) {
        glasses = glasses as GlassesValuationResponse;
        props.application.vehicle.glassesEffectiveFrom = new Date(glasses.createdOn);
        props.application.vehicle.glassesRetailTransacted = Number(glasses.retailTransacted);
        props.application.vehicle.glassesRetailValuation = glasses.retailValue;
        props.application.vehicle.glassesTradeValuation = glasses.tradeValue;
      }

      if (cap) {
        cap = cap as CapValuationResponse;
        props.application.vehicle.capRetail = cap.retailValue;
        props.application.vehicle.capClean = cap.cleanValue;
        props.application.vehicle.capAverage = cap.averageValue;
        props.application.vehicle.capCreatedOn = cap.createdOn;
      }    
    }
    catch (error) {

    }
    const toSave = {
      quickQuoteId: props.application.quickQuoteId,
      affiliateUserId: Number(props.application.affiliateUserId),
      firstName: props.application.customer!.firstName.trim(),
      surname: props.application.customer!.lastName.trim(),
      email: props.application.customer!.email,
      mobile: props.application.customer!.contactNumber,
      vehicleId: newVehicle.value!.vehicleId,
      make: newVehicle.value!.make,
      model: newVehicle.value!.model,
      registration: newVehicle.value!.vehicleRegistration.replace(" ", ""),
      registrationDate: newVehicle.value!.vehicleDateOfFirstReg,
      price: newVehicle.value!.price,
      mileage: newVehicle.value!.mileage,
      fuelType: newVehicle.value!.fuel,
      transmission: newVehicle.value?.transmission,
      deposit: props.application.deposit,
      partExValue: props.application.pxValue,
      partExSettlement: props.application.settlement,
      annualMileage: props.application.vehicle.annualMileage,
      creditProfile: filters.value.creditScore,
      created: new Date(),
      createdBy: useAuthStore().email,
      isQuickQuote: true,
      term: props.application.term,
      glassesEffectiveFrom: props.application.vehicle.glassesEffectiveFrom,
      glassesRetailTransacted: props.application.vehicle.glassesRetailTransacted,
      glassesRetailValuation: props.application.vehicle.glassesRetailValuation,
      glassesTradeValuation: props.application.vehicle.glassesTradeValuation,
      capCreatedOn: props.application.vehicle.capCreatedOn,
      capRetail: props.application.vehicle.capRetail,
      capAverage: props.application.vehicle.capAverage,
      capClean: props.application.vehicle.capClean,
      productType: props.application.productType
    } as QuickQuote

    proposalStore.createQuickQuote(toSave).then(res => {

      logEvent(EVENTS.QUICK_QUOTE_CREATE)
      resetState();
      useHideLoading();
      emit('newQuickQuote');
    }).catch(() => {
      useHideLoading();
      Dialog.create({
        title: "Oops",
        message: "We ran into an issue creating quick quote, please try again"
      }).onOk(() => {
        location.reload()
      })
    });
  }

  function resetState() {
    newVehicle.value = null;
    newVehPanel.value = "btn";
    expandAdditional.value = false;
  }

  function switchQuote(id: string) {
    emit('selectQuickQuote', id)
    expandAdditional.value = false;
  }

  const quoteState = computed(() => props.loading ? 'quoteLoadState' : ((priced.value.proposals && priced.value.proposals.length > 0) || priced.value.isQuickQuote) ? 'quoteDisplayState' : 'noProposals')
  // App to use for pricing
  const app = computed(() => {
    const p = JSON.parse(JSON.stringify(props.application)) as LoanApplication

    p.vehicle.price = filters.value.price;
    p.vehicle.mileage = filters.value.mileage;
    p.deposit = filters.value.deposit;
    p.pxValue = filters.value.pxValue;
    p.settlement = filters.value.settlement;
    p.vehicle.annualMileage = filters.value.annualMileage;

    if (p.isQuickQuote) {
      
      if (p.creditProfile !== null && p.creditProfile >= 0) {

        let props = p.proposals;

        switch (filters.value.creditScore) {
          case 2:
            props = useMockPrimeProposals(p.vehicle.price);
            props.forEach(pr => {
              pr.apr = 9.9;
            })
            break;
          case 1:
            props = [useMockHpProposal(p.vehicle.price, 13.9)]
            props[0].maxMileage = 130000;
            break;
          case 0:
          default:
            props = [useMockHpProposal(p.vehicle.price, 19.9)]
            props[0].maxMileage = 120000;
            props[0].maxLendAmount = 100000;
            break;
        }

        p.proposals = props;
      }      
    }

    return p;
  })

  const priced = ref(JSON.parse(JSON.stringify(app.value)) as LoanApplication);

  const updating = ref(false);

  async function calculatePrice() {

    priced.value.proposals = priced.value.proposals ?? props.application.proposals;

    let p = JSON.parse(JSON.stringify(app.value)) as LoanApplication;

    updating.value = true;

    const futures = await useFutures(p, p.isQuickQuote);
    
    if (futures) {
      props.application.vehicle.futuresMileage = filters.value.annualMileage;
    }

    props.application.vehicle.futures = futures;

    calculateMonthlyPaymentForVehicle(
      p.vehicle,
      p.proposals,
      p.deposit,
      p.pxValue ?? 0,
      p.customer,
      {
        annualMileage: filters.value.annualMileage,
        bespokeRates: proposalStore.bespokeRates,
        pxSettlement: p.settlement ?? 0,
        terms: [24, 36, 48, 60].concat(settingsStore.termsToShow.filter(t => ![24, 36, 48, 60].includes(t))),
        ignorePcpLender:[49],
        ignoreLTV: true,
      }
    )

    priced.value = p;

    if ((p.vehicle.pcpMatrix && p.vehicle.pcpMatrix.length > 0) && !futures) {
      p.vehicle.pcpMatrix = [];
      p.vehicle.cannotPricePCP = true;
      p.vehicle.cannotPriceReasonPCP = "Unable to get residuals"
    }

    updating.value = false;
  }

  const priceInput = ref<QInput | null>(null);
  const mileageInput = ref<QInput | null>(null);

  function quoteExternalVehicle() {
    let valid = true;

    priceInput.value!.validate() ? null : valid = false;
    mileageInput.value!.validate() ? null : valid = false;

    if (!valid) {
      return;
    }

    saveQuickQuote();
  }

  const otherVehicles = computed(() => {
    return stock.value.filter(v => !props.otherApplications.find(a => a.vehicle && a.vehicle.vehicleId === v.vehicleId) && (props.application.vehicle && props.application.vehicle.vehicleId !== v.vehicleId))
  })

  watch(() => props.application.state, () => {
    priced.value.state = props.application.state
  })

return (_ctx: any,_cache: any) => {
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_spinner = _resolveComponent("q-spinner")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(isMobile.value ? 'box-col' : 'box-row')
  }, [
    _createElementVNode("div", {
      class: "header",
      style: _normalizeStyle({'min-width': isMobile.value ? '100%' : '300px', 'width': '310px'})
    }, [
      _createVNode(_component_q_card, {
        bordered: "",
        class: "q-px-none full-width"
      }, {
        default: _withCtx(() => [
          (__props.application.isQuickQuote)
            ? (_openBlock(), _createBlock(_component_q_expansion_item, {
                key: 0,
                class: "q-pa-none full-width floating-expand",
                modelValue: expandAdditional.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((expandAdditional).value = $event))
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(VehicleAvatar, {
                        vehicle: __props.application.vehicle,
                        size: "60px"
                      }, null, 8, ["vehicle"])
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, _toDisplayString(__props.application.vehicle.make) + " " + _toDisplayString(__props.application.vehicle.model), 1),
                      _createElementVNode("div", _hoisted_5, _toDisplayString(__props.application.vehicle.mileage ? __props.application.vehicle.mileage.toLocaleString() + ' mi' : 'Unknown mileage'), 1),
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_q_badge, {
                          color: "reg-yellow",
                          style: {"padding":"2px 4px 2px 4px"},
                          class: "text-dark text-reg text-weight-bold"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(__props.application.vehicle.vehicleRegistration), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_q_card, {
                    bordered: "",
                    style: {"max-height":"400px","overflow":"auto"}
                  }, {
                    default: _withCtx(() => [
                      (!newVehicle.value)
                        ? (_openBlock(), _createBlock(_component_q_list, {
                            key: 0,
                            separator: "",
                            class: "full-width"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.otherApplications, (oa, index) => {
                                return (_openBlock(), _createBlock(_component_q_item, {
                                  key: 'oa'+index,
                                  clickable: "",
                                  class: "cursor-pointer q-px-md full-width",
                                  onClick: ($event: any) => (switchQuote(oa.id))
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_7, [
                                      _createElementVNode("div", _hoisted_8, [
                                        _createElementVNode("div", _hoisted_9, _toDisplayString(oa.vehicle.make) + " " + _toDisplayString(oa.vehicle.model), 1),
                                        _createElementVNode("div", _hoisted_10, _toDisplayString(oa.vehicle.mileage ? oa.vehicle.mileage.toLocaleString() + ' mi' : 'Unknown mileage'), 1),
                                        _createElementVNode("div", _hoisted_11, [
                                          _createVNode(_component_q_badge, {
                                            color: "reg-yellow",
                                            style: {"padding":"2px 4px 2px 4px"},
                                            class: "text-dark text-reg text-weight-bold"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(oa.vehicle.vehicleRegistration), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_12, [
                                        _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(useCurrencyFormatter)(oa.vehicle.price)), 1)
                                      ])
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              }), 128)),
                              _createVNode(_component_q_separator)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_q_tab_panels, {
                        modelValue: newVehPanel.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newVehPanel).value = $event)),
                        animated: "",
                        "transition-prev": "fade",
                        "transition-next": "fade"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tab_panel, { name: "btn" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_btn, {
                                color: "primary",
                                class: "brand-button full-width",
                                outline: "",
                                onClick: newQuote,
                                label: "Quote another vehicle"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_tab_panel, {
                            name: "veh",
                            class: "q-px-none"
                          }, {
                            default: _withCtx(() => [
                              (!newVehicle.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                    _createVNode(VehicleLookup, {
                                      onVehicleFound: vehicleFound,
                                      placeholder: "Search your stock feed or by VRM",
                                      vehicles: otherVehicles.value,
                                      ref_key: "vehicleLookup",
                                      ref: vehicleLookup
                                    }, null, 8, ["vehicles"])
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                    _createElementVNode("div", _hoisted_16, [
                                      _createElementVNode("div", _hoisted_17, _toDisplayString(newVehicle.value.make) + " " + _toDisplayString(newVehicle.value.model), 1),
                                      _createElementVNode("div", _hoisted_18, _toDisplayString(newVehicle.value.vehicleDateOfFirstReg ? new Date(newVehicle.value.vehicleDateOfFirstReg ).getFullYear() : 'Year Unknown'), 1),
                                      _createElementVNode("div", _hoisted_19, [
                                        _createVNode(_component_q_badge, {
                                          color: "reg-yellow",
                                          style: {"padding":"2px 4px 2px 4px"},
                                          class: "text-dark text-reg text-weight-bold"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(newVehicle.value.vehicleRegistration), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createElementVNode("div", _hoisted_20, [
                                        _createVNode(CurrencyInput, {
                                          modelValue: newVehicle.value.price,
                                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newVehicle.value.price) = $event)),
                                          ref_key: "priceInput",
                                          ref: priceInput,
                                          required: ""
                                        }, {
                                          default: _withCtx(() => _cache[5] || (_cache[5] = [
                                            _createElementVNode("div", { class: "q-pb-xs text-overline text-dark text-uppercase" }, "Vehicle Price*", -1)
                                          ])),
                                          _: 1,
                                          __: [5]
                                        }, 8, ["modelValue"])
                                      ]),
                                      _createElementVNode("div", _hoisted_21, [
                                        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "q-pb-xs text-overline text-dark text-uppercase" }, "Mileage", -1)),
                                        _createVNode(_unref(QInput), {
                                          outlined: "",
                                          modelValue: newVehicle.value.mileage,
                                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newVehicle.value.mileage) = $event)),
                                          modelModifiers: { number: true },
                                          ref_key: "mileageInput",
                                          ref: mileageInput,
                                          "data-cy": "mileageInput",
                                          suffix: "miles",
                                          rules: [val => (val !== null && val !== '') || 'Required', val => (val > 0) || 'Must be greater than 0'],
                                          type: "number",
                                          "hide-spin-buttons": "",
                                          min: "0",
                                          dense: "",
                                          value: "0"
                                        }, null, 8, ["modelValue", "rules"])
                                      ]),
                                      _createElementVNode("div", _hoisted_22, [
                                        _createVNode(_component_q_btn, {
                                          outline: "",
                                          color: "primary",
                                          class: "brand-button full-width",
                                          label: "Quote Vehicle",
                                          onClick: quoteExternalVehicle
                                        })
                                      ])
                                    ])
                                  ]))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "q-pt-md shadow-bottom" }, null, -1))
                ]),
                _: 1,
                __: [7]
              }, 8, ["modelValue"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(VehicleAvatar, {
                    vehicle: __props.application.vehicle,
                    size: "60px"
                  }, null, 8, ["vehicle"])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, _toDisplayString(__props.application.vehicle.make) + " " + _toDisplayString(__props.application.vehicle.model), 1),
                  _createElementVNode("div", _hoisted_27, _toDisplayString(__props.application.vehicle.mileage ? __props.application.vehicle.mileage.toLocaleString() + ' mi' : 'Unknown mileage') + "- " + _toDisplayString(new Date(__props.application.vehicle.vehicleDateOfFirstReg!).getFullYear()), 1),
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(_component_q_badge, {
                      color: "reg-yellow",
                      style: {"padding":"2px 4px 2px 4px"},
                      class: "text-dark text-reg text-subtitle2"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(useSanitiseReg)(__props.application.vehicle.vehicleRegistration)), 1)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]))
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_29, [
        _createVNode(QuoteEditor, {
          filters: filters.value,
          onUpdate: calculatePrice,
          showScore: __props.application.brokerReference > 0 ? false : true,
          loading: updating.value
        }, null, 8, ["filters", "showScore", "loading"])
      ])
    ], 4),
    _createElementVNode("div", {
      class: _normalizeClass(["content overflow-auto no-highlight", isMobile.value ? 'q-mt-md' : 'q-pl-md'])
    }, [
      _createVNode(_component_q_tab_panels, {
        modelValue: quoteState.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((quoteState).value = $event)),
        animated: "",
        "transition-prev": "fade",
        "transition-next": "fade"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_tab_panel, {
            name: "noProposals",
            class: "q-pa-none"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card, { bordered: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_card_section, { class: "flex full-width justify-center" }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createElementVNode("div", { class: "q-pl-sm text-body1 text-center" }, "No Approvals", -1)
                    ])),
                    _: 1,
                    __: [8]
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_q_tab_panel, {
            name: "quoteLoadState",
            class: "q-pa-none"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card, { bordered: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_card_section, { class: "flex full-width justify-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_spinner, { color: "primary" }),
                      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "q-pl-sm text-body1" }, "Loading Quotes", -1))
                    ]),
                    _: 1,
                    __: [9]
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_q_tab_panel, {
            name: "quoteDisplayState",
            class: "q-pa-none"
          }, {
            default: _withCtx(() => [
              _createVNode(QuoteViewer, {
                application: priced.value,
                vehicle: priced.value.vehicle,
                proposals: priced.value.proposals,
                partEx: priced.value.pxValue ?? 0,
                loading: updating.value,
                initialTerm: __props.application.term && termsToShow.value.includes(__props.application.term) ? __props.application.term : termsToShow.value[termsToShow.value.length-1]
              }, null, 8, ["application", "vehicle", "proposals", "partEx", "loading", "initialTerm"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (!__props.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_30))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}
}

})